import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useContext, useEffect, useRef, useState } from "react";
import { emitProductImpression, emitRecommenderRequest, mapSponsoredProductsTracking, SNOWPLOW_SESSION_ID, SOURCE_TYPE_ONE_RECOMMENDER } from "@catchoftheday/analytics";
import { Box, Button, Container, Heading, LoadingSpinner } from "@catchoftheday/cg-components";
import { CustomerContext } from "@catchoftheday/customer";
import { convertProductCard, ProductGrid } from "@catchoftheday/product-components";
import { centsToDollars } from "@catchoftheday/utilities";
import { ONE_RECOMMENDER_HEADING, ONE_RECOMMENDER_LIMIT, RECENTLY_VIEWED_STORAGE_KEY } from "@personalisation/consts";
import { useOneRecommenderQuery } from "@personalisation/generated/graphql";
import { handleRecommenderQueryUpdate, useVisibleRecommenderTiles } from "../utils";
import { jsx as ___EmotionJSX } from "@emotion/react";
var limit = ONE_RECOMMENDER_LIMIT;
export var OneRecommender = function OneRecommender(_ref) {
  var _fromProduct$from_pro;

  var productId = _ref.productId,
      fromProduct = _ref.fromProduct,
      sourceId = _ref.sourceId,
      offerId = _ref.offerId,
      category = _ref.category,
      adult = _ref.adult;
  var sourceType = SOURCE_TYPE_ONE_RECOMMENDER;

  var _useState = useState(),
      snowplowSessionId = _useState[0],
      setSnowplowSessionId = _useState[1];

  var _useState2 = useState(0),
      sponsoredOffset = _useState2[0],
      setSponsoredOffset = _useState2[1];

  var _useState3 = useState([]),
      recentlyViewedProductIds = _useState3[0],
      setRecentlyViewedProductIds = _useState3[1];

  var _useContext = useContext(CustomerContext),
      customerData = _useContext.data,
      customerLoading = _useContext.loading;

  var visibleCards = useVisibleRecommenderTiles({
    xs: 2,
    sm: 2,
    md: 3,
    lg: 4,
    xl: 6
  });
  useEffect(function () {
    var spId = sessionStorage.getItem(SNOWPLOW_SESSION_ID);

    if (spId) {
      setSnowplowSessionId(spId);
      return;
    } // Wait for snowplow session id to be set in session storage


    var checkSessionId = function checkSessionId(event) {
      if (event.key === SNOWPLOW_SESSION_ID) {
        setSnowplowSessionId(event.newValue);
      }
    };

    window.addEventListener("storage", checkSessionId);
    return function () {
      return window.removeEventListener("storage", checkSessionId);
    };
  }, []);
  useEffect(function () {
    var recentlyViewedItems = localStorage.getItem(RECENTLY_VIEWED_STORAGE_KEY);

    if (recentlyViewedItems) {
      var _recentlyViewedData$p;

      var recentlyViewedData = JSON.parse(recentlyViewedItems);
      var productIds = (_recentlyViewedData$p = recentlyViewedData.products) === null || _recentlyViewedData$p === void 0 ? void 0 : _recentlyViewedData$p.map(function (product) {
        return product.id;
      });
      setRecentlyViewedProductIds(productIds);
    }
  }, []);
  var trackingVariables = useRef({
    offset: 0,
    limit: limit
  });
  var sponsoredProductsInput = {
    limit: visibleCards,
    offset: 0,
    inventoryId: "product_page_recommender",
    snowplowSessionId: snowplowSessionId,
    customerUUID: customerData === null || customerData === void 0 ? void 0 : customerData.metaData.customerUuid,
    offerId: offerId,
    category: category,
    pageId: "product",
    excludeProductIds: (_fromProduct$from_pro = fromProduct.from_product_ids) === null || _fromProduct$from_pro === void 0 ? void 0 : _fromProduct$from_pro.map(function (id) {
      return "".concat(id);
    })
  };

  var _useOneRecommenderQue = useOneRecommenderQuery({
    variables: {
      productId: productId,
      recentlyViewedProductIds: recentlyViewedProductIds,
      limit: limit,
      offset: 0,
      includeAdultCategory: adult,
      sponsoredProductsInput: sponsoredProductsInput
    },
    ssr: false,
    notifyOnNetworkStatusChange: true,
    onCompleted: function onCompleted() {
      emitRecommenderRequest(_objectSpread({
        source_type: sourceType,
        page_offset: trackingVariables.current.offset,
        page_limit: trackingVariables.current.limit
      }, fromProduct));
    },
    skip: customerLoading || !snowplowSessionId
  }),
      data = _useOneRecommenderQue.data,
      error = _useOneRecommenderQue.error,
      loading = _useOneRecommenderQue.loading,
      fetchMore = _useOneRecommenderQue.fetchMore;

  function loadMore() {
    return _loadMore.apply(this, arguments);
  }

  function _loadMore() {
    _loadMore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _response$data;

      var response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetchMore({
                variables: {
                  offset: nextItemIndex,
                  sponsoredProductsInput: _objectSpread(_objectSpread({}, sponsoredProductsInput), {}, {
                    offset: sponsoredOffset + visibleCards
                  })
                },
                updateQuery: function updateQuery(prevResult, _ref2) {
                  var fetchMoreResult = _ref2.fetchMoreResult;
                  return handleRecommenderQueryUpdate({
                    prevResult: prevResult,
                    fetchMoreResult: fetchMoreResult,
                    recommenderKey: "oneRecommender"
                  });
                }
              });

            case 2:
              response = _context.sent;

              if ((_response$data = response.data) !== null && _response$data !== void 0 && _response$data.oneRecommender.products.length) {
                setSponsoredOffset(sponsoredOffset + visibleCards);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _loadMore.apply(this, arguments);
  }

  if (!(data !== null && data !== void 0 && data.oneRecommender.products.length) || error) {
    return null;
  }

  var products = data.oneRecommender.products;
  var _data$oneRecommender$ = data.oneRecommender.pagination,
      nextItemIndex = _data$oneRecommender$.nextItemIndex,
      totalCount = _data$oneRecommender$.totalCount;
  var productItems = products.map(function (result) {
    return convertProductCard(_objectSpread(_objectSpread({}, result), {}, {
      sourceType: sourceType,
      sourceId: sourceId
    }), result.selectedOffer);
  });
  var impressionTrackingData = productItems.reduce(function (acc, productItem, index) {
    if (!productItem.isSponsored) {
      acc[productItem.id] = function () {
        return emitProductImpression(_objectSpread({
          offer_id: Number(productItem.offerId),
          source_id: sourceId,
          source_position: index + 1,
          source_type: sourceType,
          product_id: Number(productItem.id),
          product_title: productItem.title,
          displayed_price: productItem.priceTag ? centsToDollars(productItem.priceTag.priceLabel.price.amount) : null
        }, fromProduct));
      };
    }

    return acc;
  }, {});
  return ___EmotionJSX(Container, {
    py: 5,
    px: 2,
    flexDirection: "column",
    alignItems: "center"
  }, ___EmotionJSX(Heading.h3, null, ONE_RECOMMENDER_HEADING), ___EmotionJSX(Box, {
    width: "100%"
  }, ___EmotionJSX(ProductGrid, {
    productItems: productItems,
    gridTemplateColumns: {
      sm: "repeat(2, 1fr)",
      md: "repeat(3, 1fr)",
      lg: "repeat(4, 1fr)",
      xl: "repeat(6, 1fr)"
    },
    sponsoredItemsTracking: mapSponsoredProductsTracking(data.oneRecommender.metaData.sponsoredProductsTracking),
    impressionTracking: impressionTrackingData
  })), nextItemIndex < totalCount && ___EmotionJSX(Box, {
    pt: 8,
    pb: 4
  }, loading ? ___EmotionJSX(LoadingSpinner, null) : ___EmotionJSX(Button, {
    id: "one-recommender-load-more-button",
    minWidth: "200px",
    outline: true,
    size: "sm",
    variant: "secondary",
    onClick: loadMore
  }, "Load more")));
};